import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { scheduledCardsQueryOptions } from '../lib/queries';

export function useScheduledCards(isAuthenticated: boolean) {
  const { data: cards = [], isLoading } = useQuery({
    ...scheduledCardsQueryOptions(),
    enabled: isAuthenticated,
  });

  const { dueNow, upcoming } = useMemo(() => {
    const now = Date.now();
    const due: typeof cards = [];
    const later: typeof cards = [];

    for (const card of cards) {
      if (new Date(card.due).getTime() <= now) {
        due.push(card);
      } else {
        later.push(card);
      }
    }

    return { dueNow: due, upcoming: later };
  }, [cards]);

  return { dueNow, upcoming, totalCount: cards.length, isLoading };
}
